var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }